import { Popover } from 'antd';
import React from 'react';
import { Progress } from 'reactstrap';
import { connect } from 'dva';
import { data } from './RiskTypeData';

const RiskProgressBar = props => {
  const { singleRisk } = props;
  let riskTypesObject = {};
  Object.keys(singleRisk?.riskTypes).map(category => {
    let key = category.replace(/\s/g, '').toLowerCase();
    let value = singleRisk.riskTypes[category];
    riskTypesObject[key] = value;
  });
  let total = Object.values(singleRisk.riskTypes).reduce((acc, number) => acc + number, 0);

  function formatHeading(text) {
    const result = text.replace(/([A-Z])/g, ' $1');
    let finalResult = result.charAt(0).toUpperCase() + result.slice(1);
    finalResult = finalResult.replace(/([^a-zA-Z0-9_-]|^)I A M(?![a-zA-Z0-9_-])/g, 'IAM');
    finalResult = finalResult.replace(/([^a-zA-Z0-9_-]|^)Os(?![a-zA-Z0-9_-])/g, 'OS');
    return finalResult;
  }

  const content = name => {
    return (
      <p style={{ marginLeft: '10px' }}>
        {`Total ${formatHeading(name)}: `}
        {riskTypesObject[name.toLowerCase()] || 0}
      </p>
    );
  };

  return (
    <Progress
      max={100}
      style={{
        marginLeft: '-20px',
        height: '5px',
        marginTop: '10px',
        gridGap: '1px',
        gap: '1px',
        background: 'transparent',
      }}
      multi
    >
      {Object.keys(data).map(each => {
        return (
          <Popover title={formatHeading(each)} content={content(each)}>
            <Progress
              bar
              style={{ backgroundColor: data[each].style.color, gap: '0.2rem' }}
              value={(riskTypesObject[each.toLowerCase()] / total) * 100}
            />
          </Popover>
        );
      })}
    </Progress>
  );
};
export default connect(({ singleRisk }) => ({
  singleRisk,
}))(RiskProgressBar);
